import { Component} from '@angular/core';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-version',
  styleUrls: ['./version.component.scss'],
  templateUrl: './version.component.html'
})
export class AppVersionComponent {
  versionInfo;
  buildEnv = '';
  constructor() {
    this.buildEnv = environment.envname;
    if (environment.version && environment.version.date) {
      this.versionInfo = environment.version;
    } else {
      this.versionInfo = 'No Version Available Run Npm Build Or Version Script';
    }
  }
}
